import styled, { css } from 'styled-components';

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TextStyled = styled.span`
  white-space: nowrap;
`;

export const GridWrapperStyled = styled.div<{ showProgressBars: boolean }>`
  width: 100%;
  display: grid;
  ${({ showProgressBars }) =>
    showProgressBars
      ? css`
          grid-template-columns: auto 200px 1fr;
        `
      : css`
          grid-template-columns: auto 1fr;
        `}

  align-items: center;
  justify-items: start;
  gap: 8px;
`;
